/**
 * CrazyEgg Adapter
 *
 * CrazyEgg is primarily used for heatmaps, recordings, and A/B testing.
 * It doesn't track traditional ecommerce events, only pixel load.
 *
 * This adapter is included for consistency but returns null for all events
 * since CrazyEgg doesn't use event-based tracking in the same way as other pixels.
 *
 * @since 1.56.0
 */

(function (pmw, undefined) {

	class CrazyeggAdapter {

		/**
		 * Adapt event data to CrazyEgg format
		 *
		 * CrazyEgg doesn't track traditional ecommerce events, so this always returns null.
		 * The pixel is loaded via the pmw:load-pixels event, not through event-specific triggers.
		 *
		 * @param {object} eventData - Event-specific data (product, order, etc.)
		 * @param {string} eventName - Standardized event name
		 * @param {object} context - Event context (user, page, etc.)
		 * @returns {null} Always null - CrazyEgg doesn't use event tracking
		 */
		adapt(eventData, eventName, context) {
			// CrazyEgg doesn't track ecommerce events
			// It only loads the tracking script for session recordings and heatmaps
			return null;
		}
	}

	// Register the adapter
	pmw.registerAdapter('crazyegg', new CrazyeggAdapter(), {
		supportsS2S               : false,
		supportsEventDeduplication: false,
		isActive                  : () => pmwDataLayer?.pixels?.crazyegg?.account_number ? true : false
	});

}(window.pmw = window.pmw || {}));
